import React, { useEffect, useRef } from 'react';
import { Box } from '../Box/Box';
import { RenderInView } from './RenderInView';
import { SlideWrapper } from './SlideBox.styled';
export function Slide({
  onSlideChange,
  slideSpacing,
  stretchHeight,
  index,
  content,
  isCurrentSlide,
  width,
  numSlides,
  slideBoxRef,
  overflowAllowancePxX
}) {
  const ref = useRef();
  useEffect(() => {
    /* istanbul ignore next */
    if (isCurrentSlide === true && typeof slideBoxRef?.current?.scroll === 'function' && ref?.current) {
      const {
        offsetLeft,
        offsetParent,
        offsetWidth
      } = ref.current;
      const {
        offsetWidth: parentOffset
      } = offsetParent || {};
      slideBoxRef?.current?.scroll({
        left: offsetLeft - parentOffset + offsetWidth + overflowAllowancePxX
      });
    }
  }, [isCurrentSlide, ref]);
  return React.createElement(SlideWrapper, {
    "data-testid": `slide${index + 1}`,
    ref: ref,
    width: width
  }, React.createElement(RenderInView, {
    onSlideChange: onSlideChange,
    index: index,
    slideRef: ref
  }, React.createElement(Box, {
    height: '100%',
    pl: index === 0 ? 2 : 0,
    pr: index === numSlides - 1 ? 2 : 0,
    ml: index === 0 ? 0 : slideSpacing,
    mr: index === numSlides - 1 ? 0 : slideSpacing
  }, stretchHeight && React.isValidElement(content) ? React.cloneElement(content, {
    style: {
      'min-height': '100%'
    }
  }) : content)));
}